import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
  static values = {
    config: Object
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initChart() {
    const config = this.configValue

    // Primary color (Tailwind green-500: #22c55e)
    const primaryColor = '#22c55e'

    // Detect dark mode
    const isDarkMode = document.documentElement.classList.contains('dark') ||
                       window.matchMedia('(prefers-color-scheme: dark)').matches

    // Colors based on mode
    const textColor = isDarkMode ? '#94a3b8' : '#64748b'  // slate-400 / slate-500
    const gridColor = isDarkMode ? 'rgba(148, 163, 184, 0.2)' : 'rgba(100, 116, 139, 0.2)'

    // Customize the chart for better appearance
    config.options = config.options || {}
    config.options.responsive = true
    config.options.maintainAspectRatio = false
    config.options.scales = config.options.scales || {}
    config.options.scales.r = config.options.scales.r || {}
    config.options.scales.r.min = -2
    config.options.scales.r.max = 2
    config.options.scales.r.ticks = {
      stepSize: 1,
      display: true,
      color: textColor,
      backdropColor: 'transparent'
    }
    config.options.scales.r.pointLabels = {
      font: {
        size: 11
      },
      color: textColor
    }
    config.options.scales.r.grid = {
      color: gridColor
    }
    config.options.scales.r.angleLines = {
      color: gridColor
    }
    config.options.plugins = config.options.plugins || {}
    config.options.plugins.legend = {
      labels: {
        color: textColor
      }
    }

    // The solid dataset is the headline series; dashed ones (lowest/highest) show the range.
    const rangeColor = isDarkMode ? '#64748b' : '#94a3b8'  // slate-500 / slate-400
    const datasets = (config.data && config.data.datasets) || []
    datasets.forEach((dataset) => {
      if (dataset.borderDash) {
        dataset.borderColor = rangeColor
        dataset.pointBackgroundColor = rangeColor
        dataset.pointRadius = 2
        dataset.backgroundColor = 'transparent'
      } else {
        dataset.backgroundColor = 'rgba(34, 197, 94, 0.2)'
        dataset.borderColor = primaryColor
        dataset.pointBackgroundColor = primaryColor
        dataset.pointBorderColor = isDarkMode ? '#334155' : '#fff'
        dataset.pointHoverBackgroundColor = isDarkMode ? '#334155' : '#fff'
        dataset.pointHoverBorderColor = primaryColor
      }
    })

    this.chart = new Chart(this.element, config)
  }
}
